// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sms-portal-view-template-table-container {
  margin: 1rem auto;
  width: fit-content;
}

#sms-portal-view-template-table-container h4 {
  font-size: 2rem;
  color: #52616a;
  border-bottom: 1px solid #dcdcdc;
  padding-bottom: 0.25rem;
  text-align: center;
  margin-top: 3rem;
  margin-bottom: 1rem;
}

#sms-portal-view-template-table-container .sms-portal-view-template-table th {
  margin: 2rem 0 1rem 2rem;
  padding: 1rem !important;
  line-height: 1.5rem;
  font-size: 0.8rem;
  text-align: left;
  word-wrap: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#sms-portal-view-template-table-container
  .sms-portal-view-template-table
  thead {
  background-color: #f5f5f5;
  border: 1px solid #dcdcdc;
}

#sms-portal-view-template-table-container,
#sms-portal-view-template-table-container table {
  min-width: 1000px;
}

#sms-portal-view-template-table-container .sms-portal-view-template-table td {
  border: 0 !important;
  margin: 2rem 0 1rem 2rem;
  padding: 1rem !important;
  line-height: 1.5rem;
  font-size: 0.8rem;
}

#sms-portal-view-template-table-container table tr:nth-child(even) {
  background-color: #f5f5f5;
}

.sms-portal-view-template-table-date-filter-container {
  position: relative;
}

.sms-portal-filter-name {
  font-size: 0.8rem;
  padding-right: 0.5rem;
}

.sms-portal-filter-triangle-up {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 7px solid #dcdcdc;
}

.sms-portal-filter-triangle-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 7px solid #dcdcdc;
}

.sms-portal-date-filter-box {
  display: flex;
  align-items: center;
  border: 1px solid #dcdcdc;
  width: fit-content;
  padding: 0.35rem 0.5rem;
  margin: 0.5rem 0 0.5rem 1rem;
  cursor: pointer;
}

.sms-portal-date-filter-dropdown {
  position: absolute;
  background: #fff;
  border: 1px solid #dcdcdc;
  right: 0;
}

.sms-portal-date-filter-dropdown .react-datepicker__input-container input {
  border: 1px solid #dcdcdc;
  width: 94px;
  text-align: center;
  height: 25px;
}

.sms-portal-filter-curtain {
  position: absolute;
  border-right: 1px solid #dcdcdc;
  border-left: 1px solid #dcdcdc;
  width: 7rem;
  height: 1rem;
  background: #fff;
  z-index: 9;
  top: 38px;
  right: 0;
}

.sms-portal-date-select-container {
  margin: 0.5rem;
}

.sms-portal-date-select {
  font-size: 0.7rem;
  margin: 0.25rem 0;
}

.sms-portal-date-filter-apply-btn-container {
  border-top: 1px solid #dcdcdc;
  padding-top: 0.5rem;
  padding-right: 0.5rem;
}

.sms-portal-date-filter-apply-btn {
  border: none;
  background: #f05a9b;
  font-size: 0.8rem;
  border-radius: 5px;
  color: #fff;
  float: right;
  padding: 0.15rem 0.75rem;
  margin-bottom: 0.5rem;
  outline: none;
}

.sms-portal-edit-template-table-values-container
  button.sms-portal-date-filter-apply-btn {
  margin-right: 0.75rem;
}

.sms-portal-date-filter-apply-btn-disabled {
  border: none;
  background: #dcdcdc;
  font-size: 0.8rem;
  border-radius: 5px;
  color: #fff;
  float: right;
  padding: 0.15rem 0.75rem;
  margin-bottom: 0.5rem;
  outline: none;
  cursor: not-allowed;
}

.sms-portal-edit-template-table-values-container {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9991;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.sms-portal-edit-template-table-values-container span {
  margin: 0 0.8rem;
  font-weight: 500;
  color: #333;
}

.sms-portal-edit-popup-input-container {
  margin-bottom: 0.8rem;
}

.sms-portal-edit-template-close {
  background-color: #52616a;
  color: #fff !important;
  border-radius: 50%;
  cursor: pointer;
  float: right;
  padding: 1px 5px;
  font-size: 0.6rem;
}

.sms-portal-view-template-table-filters-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sms-portal-view-template-left-end-filters-container {
  display: flex;
}

.sms-portal-dlt-check-boxes {
  padding: 0.5rem;
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
}

.sms-portal-dlt-filter-curtain {
  position: absolute;
  border-right: 1px solid #dcdcdc;
  border-left: 1px solid #dcdcdc;
  width: 9.25rem;
  height: 1rem;
  background: #fff;
  z-index: 9;
  top: 32px;
  right: 0;
}

.sms-portal-sort-by-curtain {
  position: absolute;
  border-right: 1px solid #dcdcdc;
  border-left: 1px solid #dcdcdc;
  width: 4.95rem;
  height: 1rem;
  background: #fff;
  z-index: 9;
  top: 32px;
  left: 16px;
}

.sms-portal-dlt-check-boxes span {
  font-size: 0.8rem;
  margin-left: 0.5rem;
}

.sms-portal-dlt-check-boxes input {
  margin-top: 0;
}

.sms-portal-sms-type-filter-dropdown {
  position: absolute;
  background: #fff;
  border: 1px solid #dcdcdc;
  width: 9.3rem;
  right: 0;
}

.sms-portal-sms-type-filter-box {
  display: flex;
  align-items: center;
  border: 1px solid #dcdcdc;
  width: 148.8px;
  padding: 0.35rem 0.5rem;
  margin: 0.5rem 0 0.5rem 1rem;
  cursor: pointer;
}

.sms-portal-template-table-disclaimer {
  color: #b4b4be;
  padding-top: 2rem;
  font-size: 0.8rem;
  display: flex;
  justify-content: center;
}

.sms-portal-template-table-capitalize {
  text-transform: lowercase;
}

.sms-portal-template-table-capitalize:first-letter {
  text-transform: capitalize;
}

.sms-portal-sort-by-dropdown {
  position: absolute;
  background: #fff;
  border: 1px solid #dcdcdc;
  width: max-content;
  left: 16px;
}

.sms-portal-sms-type-filter-curtain {
  position: absolute;
  border-right: 1px solid #dcdcdc;
  border-left: 1px solid #dcdcdc;
  width: 9.28rem;
  height: 1rem;
  background: #fff;
  z-index: 9;
  top: 32px;
  right: 0;
}

.sms-portal-dlt-filter-dropdown {
  position: absolute;
  background: #fff;
  border: 1px solid #dcdcdc;
  width: 9.25rem;
  right: 0;
}

.sms-portal-sort-by-radio-box {
  padding: 0.5rem;
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  justify-content: space-between;
}

.sms-portal-sort-by-radio-box span {
  font-size: 0.8rem;
  margin-left: 0.5rem;
}
.sms-portal-sort-by-dropdown select {
  border: none;
  border-radius: 2px;
  background-color: #f5f5f5;
  padding: 0.2rem 0.5rem;
  font-size: 0.8rem;
  margin: 0 1rem 0 0.5rem;
  outline: none;
}

.sms-portal-template-table-active-filters-list-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 0.5rem;
}

.sms-portal-template-table-active-filters-list-container span {
  font-size: 0.7rem;
  background-color: #f5f5f5;
  border-radius: 20px;
  color: #52616a;
  padding: 0.15rem 0.5rem;
  margin-left: 0.5rem;
}

.sms-portal-update-template-table-select {
  border: none;
  border-radius: 2px;
  background-color: #f5f5f5;
  padding: 0.2rem 0.5rem;
  font-size: 0.8rem;
  margin: 0 0.75rem 0 0.5rem;
  outline: none;
  float: right;
}

.sms-portal-update-template-table-provider-container {
  margin-bottom: 1rem;
}

.sms-portal-update-template-table-provider-container span {
  font-size: 0.8rem;
  color: #52616a;
}

.sms-portal-update-template-provider-status-title {
  margin: 1rem 0 0.5rem 0.75rem;
  font-size: 1rem;
}

.sms-portal--update-popup-dlt-status-select-container {
  display: block;
  margin-left: 1rem;
}

.sms-portal-update-dlt-status-select {
  border: none;
  border-radius: 2px;
  background-color: #f5f5f5;
  padding: 0.5rem 0.5rem;
  font-size: 0.8rem;
  outline: none;
  float: right;
  margin: 0.25rem 0.75rem 1rem 0;
  font-weight: 500;
  width: 97%;
}

.sms-portal-update-template-table-provider-outer-container {
  margin-left: 0.25rem;
}

.sms-portal-top-button-container {
  margin: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sms-portal-link-button {
  background-color: #f05a9b;
  font-size: 1rem;
  font-weight: 400;
  transition: 0.3s;
  padding: 1.5rem 0;
  border-radius: 5px;
  color: #fff;
  margin: 1rem;
  width: 12%;
  text-align: center;
}

.sms-portal-link-button:hover {
  background-color: #d42d76;
  transition: 0.3s;
  color: #fff;
}

.sms-portal-table-section-divider {
  height: 1px;
  width: 100%;
  background-color: #dcdcdc;
}

.sms-portal-temple-list-header {
  font-size: 0.9rem;
  color: #52616a;
}

.sms-portal-create-template-container {
  max-width: 800px;
  margin: 0 auto;
  margin-top: 2rem;
}

form.sms-portal-create-template-container span {
  font-size: 0.8rem;
  font-weight: 500;
}

form.sms-portal-create-template-container
  .Select.basic-single.is-clearable.is-searchable.Select--single {
  margin-top: 0;
}

form.sms-portal-create-template-container .Select-placeholder {
  font-size: 0.8rem;
}

form.sms-portal-create-template-container h4 {
  font-size: 2rem;
  text-align: center;
  padding-bottom: 0.5rem;
  width: fit-content;
  margin: auto;
  margin-bottom: 1rem;
}

.sms-content-important-container {
  display: flex;
  justify-content: space-between;
}

.sms-content-important-container .important-container {
  font-size: 12px;
  width: 35%;
}

.sms-content-important-container b span{
  color: red;
}

.sms-portal-create-template-input-width{
  width: 60%;
}

.sms-portal-create-template-button {
  background-color: #f05a9b;
  font-size: 1rem;
  font-weight: 400;
  transition: 0.3s;
  border-radius: 5px;
  color: #fff;
  padding: 0.5rem 1rem;
  text-align: center;
  border: none;
  outline: none;
}

.sms-portal-create-template-button-disabled {
  background-color: #dcdcdc;
  font-size: 1rem;
  font-weight: 400;
  transition: 0.3s;
  border-radius: 5px;
  color: #666;
  padding: 0.5rem 1rem;
  text-align: center;
  border: none;
  outline: none;
  cursor: no-drop !important;
}

.sms-portal-create-template-button:hover {
  background-color: #d42d76;
  transition: 0.3s;
  color: #fff;
}

form.sms-portal-create-template-container .Select-menu-outer {
  font-size: 0.8rem;
}

.sms-portal-create-template-button-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
}

.sms-portal-create-template-note {
  margin-top: 1rem;
  font-size: 0.8rem;
}

.sms-portal-create-template-sample-button {
  border: none;
  color: #f05a9b;
  padding: 0;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
  border: none;
  outline: none;
  background-color: transparent;
}

.sms-portal-create-template-form-error {
}

.sms-portal-create-template-note li {
  list-style: disc;
  margin-left: 1rem;
}

form.sms-portal-create-template-container input.form-control {
  margin-bottom: 0.5rem;
}

.sms-portal-textarea-counts-container {
  display: flex;
  justify-content: space-between;
}

.sms-portal-error-list-container {
  list-style: disc;
  margin-left: 1rem;
  font-size: 0.8rem;
}

span.sms-portal-desc-text-counter,
span.sms-portal-total-sms-counter {
  text-transform: lowercase;
  margin-top: 0.25rem;
}

.sms-todo-list-item-green {
  color: green;
}

.sms-todo-list-item-red {
  color: #f05a9b;
}

.sms-portal-create-template-form-error h6 {
  margin-bottom: 0;
  margin-top: 1rem;
}

td.sms-portal-template-data {
  max-width: 16rem;
  word-wrap: break-word;
}

.sms-portal-create-template-form-errors {
  color: rgba(214, 27, 27, 0.89);
}

form.sms-portal-create-template-container span.Select-clear-zone {
  display: none;
}

.sms-portal-create-template-form-errors h6 {
  margin-bottom: 0;
}

.sms-portal-success-icon {
  display: inline-block;
  transform: rotate(45deg);
  height: 24px;
  width: 12px;
  border-bottom: 7px solid #78b13f;
  border-right: 7px solid #78b13f;
}

span.sms-portal-failure-icon {
  background-color: rgba(214, 27, 27, 0.89);
  font-size: 1.5rem;
  border-radius: 50%;
  padding: 0.5rem 1.2rem;
  color: #fff;
  line-height: 2;
}

.sms-portal-template-update-post-success-container {
  text-align: center;
  padding: 5rem;
}

.sms-portal-view-template-details-data-container {
  display: grid;
  grid-template-columns: 1fr 2fr;
  text-transform: lowercase;
}

.sms-portal-view-template-details-data-container::first-letter {
  text-transform: capitalize;
}

.sms-portal-view-template-details-keys {
  display: grid;
}

.sms-portal-edit-template-table-values-container .card-container {
  width: auto;
  max-width: 24vw;
  max-height: 80vh;
  overflow: auto;
}

.sms-portal-view-table-data {
  display: grid;
  grid-template-columns: 1.2fr 2fr;
  align-items: center;
  text-align: left;
  margin-top: 1rem;
  font-size: 0.9rem;
}

span.sms-portal-view-table-data-value {
  font-weight: 400;
  font-size: 0.8rem;
}

table.sms-portal-view-template-table button.link-type-button {
  margin-right: 0.5rem;
}

p.sms-portal-view-template-details-provider-status-text {
  margin-left: 0.75rem;
  margin-top: 0.5rem;
  color: #000;
  margin-bottom: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./client/components/styles/sms-portal.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;EACP,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,6BAA6B;AAC/B;;AAEA;AACA;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,2BAA2B;AAC7B","sourcesContent":["#sms-portal-view-template-table-container {\n  margin: 1rem auto;\n  width: fit-content;\n}\n\n#sms-portal-view-template-table-container h4 {\n  font-size: 2rem;\n  color: #52616a;\n  border-bottom: 1px solid #dcdcdc;\n  padding-bottom: 0.25rem;\n  text-align: center;\n  margin-top: 3rem;\n  margin-bottom: 1rem;\n}\n\n#sms-portal-view-template-table-container .sms-portal-view-template-table th {\n  margin: 2rem 0 1rem 2rem;\n  padding: 1rem !important;\n  line-height: 1.5rem;\n  font-size: 0.8rem;\n  text-align: left;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#sms-portal-view-template-table-container\n  .sms-portal-view-template-table\n  thead {\n  background-color: #f5f5f5;\n  border: 1px solid #dcdcdc;\n}\n\n#sms-portal-view-template-table-container,\n#sms-portal-view-template-table-container table {\n  min-width: 1000px;\n}\n\n#sms-portal-view-template-table-container .sms-portal-view-template-table td {\n  border: 0 !important;\n  margin: 2rem 0 1rem 2rem;\n  padding: 1rem !important;\n  line-height: 1.5rem;\n  font-size: 0.8rem;\n}\n\n#sms-portal-view-template-table-container table tr:nth-child(even) {\n  background-color: #f5f5f5;\n}\n\n.sms-portal-view-template-table-date-filter-container {\n  position: relative;\n}\n\n.sms-portal-filter-name {\n  font-size: 0.8rem;\n  padding-right: 0.5rem;\n}\n\n.sms-portal-filter-triangle-up {\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-bottom: 7px solid #dcdcdc;\n}\n\n.sms-portal-filter-triangle-down {\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 7px solid #dcdcdc;\n}\n\n.sms-portal-date-filter-box {\n  display: flex;\n  align-items: center;\n  border: 1px solid #dcdcdc;\n  width: fit-content;\n  padding: 0.35rem 0.5rem;\n  margin: 0.5rem 0 0.5rem 1rem;\n  cursor: pointer;\n}\n\n.sms-portal-date-filter-dropdown {\n  position: absolute;\n  background: #fff;\n  border: 1px solid #dcdcdc;\n  right: 0;\n}\n\n.sms-portal-date-filter-dropdown .react-datepicker__input-container input {\n  border: 1px solid #dcdcdc;\n  width: 94px;\n  text-align: center;\n  height: 25px;\n}\n\n.sms-portal-filter-curtain {\n  position: absolute;\n  border-right: 1px solid #dcdcdc;\n  border-left: 1px solid #dcdcdc;\n  width: 7rem;\n  height: 1rem;\n  background: #fff;\n  z-index: 9;\n  top: 38px;\n  right: 0;\n}\n\n.sms-portal-date-select-container {\n  margin: 0.5rem;\n}\n\n.sms-portal-date-select {\n  font-size: 0.7rem;\n  margin: 0.25rem 0;\n}\n\n.sms-portal-date-filter-apply-btn-container {\n  border-top: 1px solid #dcdcdc;\n  padding-top: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.sms-portal-date-filter-apply-btn {\n  border: none;\n  background: #f05a9b;\n  font-size: 0.8rem;\n  border-radius: 5px;\n  color: #fff;\n  float: right;\n  padding: 0.15rem 0.75rem;\n  margin-bottom: 0.5rem;\n  outline: none;\n}\n\n.sms-portal-edit-template-table-values-container\n  button.sms-portal-date-filter-apply-btn {\n  margin-right: 0.75rem;\n}\n\n.sms-portal-date-filter-apply-btn-disabled {\n  border: none;\n  background: #dcdcdc;\n  font-size: 0.8rem;\n  border-radius: 5px;\n  color: #fff;\n  float: right;\n  padding: 0.15rem 0.75rem;\n  margin-bottom: 0.5rem;\n  outline: none;\n  cursor: not-allowed;\n}\n\n.sms-portal-edit-template-table-values-container {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 9991;\n  background-color: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sms-portal-edit-template-table-values-container span {\n  margin: 0 0.8rem;\n  font-weight: 500;\n  color: #333;\n}\n\n.sms-portal-edit-popup-input-container {\n  margin-bottom: 0.8rem;\n}\n\n.sms-portal-edit-template-close {\n  background-color: #52616a;\n  color: #fff !important;\n  border-radius: 50%;\n  cursor: pointer;\n  float: right;\n  padding: 1px 5px;\n  font-size: 0.6rem;\n}\n\n.sms-portal-view-template-table-filters-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sms-portal-view-template-left-end-filters-container {\n  display: flex;\n}\n\n.sms-portal-dlt-check-boxes {\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n}\n\n.sms-portal-dlt-filter-curtain {\n  position: absolute;\n  border-right: 1px solid #dcdcdc;\n  border-left: 1px solid #dcdcdc;\n  width: 9.25rem;\n  height: 1rem;\n  background: #fff;\n  z-index: 9;\n  top: 32px;\n  right: 0;\n}\n\n.sms-portal-sort-by-curtain {\n  position: absolute;\n  border-right: 1px solid #dcdcdc;\n  border-left: 1px solid #dcdcdc;\n  width: 4.95rem;\n  height: 1rem;\n  background: #fff;\n  z-index: 9;\n  top: 32px;\n  left: 16px;\n}\n\n.sms-portal-dlt-check-boxes span {\n  font-size: 0.8rem;\n  margin-left: 0.5rem;\n}\n\n.sms-portal-dlt-check-boxes input {\n  margin-top: 0;\n}\n\n.sms-portal-sms-type-filter-dropdown {\n  position: absolute;\n  background: #fff;\n  border: 1px solid #dcdcdc;\n  width: 9.3rem;\n  right: 0;\n}\n\n.sms-portal-sms-type-filter-box {\n  display: flex;\n  align-items: center;\n  border: 1px solid #dcdcdc;\n  width: 148.8px;\n  padding: 0.35rem 0.5rem;\n  margin: 0.5rem 0 0.5rem 1rem;\n  cursor: pointer;\n}\n\n.sms-portal-template-table-disclaimer {\n  color: #b4b4be;\n  padding-top: 2rem;\n  font-size: 0.8rem;\n  display: flex;\n  justify-content: center;\n}\n\n.sms-portal-template-table-capitalize {\n  text-transform: lowercase;\n}\n\n.sms-portal-template-table-capitalize:first-letter {\n  text-transform: capitalize;\n}\n\n.sms-portal-sort-by-dropdown {\n  position: absolute;\n  background: #fff;\n  border: 1px solid #dcdcdc;\n  width: max-content;\n  left: 16px;\n}\n\n.sms-portal-sms-type-filter-curtain {\n  position: absolute;\n  border-right: 1px solid #dcdcdc;\n  border-left: 1px solid #dcdcdc;\n  width: 9.28rem;\n  height: 1rem;\n  background: #fff;\n  z-index: 9;\n  top: 32px;\n  right: 0;\n}\n\n.sms-portal-dlt-filter-dropdown {\n  position: absolute;\n  background: #fff;\n  border: 1px solid #dcdcdc;\n  width: 9.25rem;\n  right: 0;\n}\n\n.sms-portal-sort-by-radio-box {\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n  justify-content: space-between;\n}\n\n.sms-portal-sort-by-radio-box span {\n  font-size: 0.8rem;\n  margin-left: 0.5rem;\n}\n.sms-portal-sort-by-dropdown select {\n  border: none;\n  border-radius: 2px;\n  background-color: #f5f5f5;\n  padding: 0.2rem 0.5rem;\n  font-size: 0.8rem;\n  margin: 0 1rem 0 0.5rem;\n  outline: none;\n}\n\n.sms-portal-template-table-active-filters-list-container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: 0.5rem;\n}\n\n.sms-portal-template-table-active-filters-list-container span {\n  font-size: 0.7rem;\n  background-color: #f5f5f5;\n  border-radius: 20px;\n  color: #52616a;\n  padding: 0.15rem 0.5rem;\n  margin-left: 0.5rem;\n}\n\n.sms-portal-update-template-table-select {\n  border: none;\n  border-radius: 2px;\n  background-color: #f5f5f5;\n  padding: 0.2rem 0.5rem;\n  font-size: 0.8rem;\n  margin: 0 0.75rem 0 0.5rem;\n  outline: none;\n  float: right;\n}\n\n.sms-portal-update-template-table-provider-container {\n  margin-bottom: 1rem;\n}\n\n.sms-portal-update-template-table-provider-container span {\n  font-size: 0.8rem;\n  color: #52616a;\n}\n\n.sms-portal-update-template-provider-status-title {\n  margin: 1rem 0 0.5rem 0.75rem;\n  font-size: 1rem;\n}\n\n.sms-portal--update-popup-dlt-status-select-container {\n  display: block;\n  margin-left: 1rem;\n}\n\n.sms-portal-update-dlt-status-select {\n  border: none;\n  border-radius: 2px;\n  background-color: #f5f5f5;\n  padding: 0.5rem 0.5rem;\n  font-size: 0.8rem;\n  outline: none;\n  float: right;\n  margin: 0.25rem 0.75rem 1rem 0;\n  font-weight: 500;\n  width: 97%;\n}\n\n.sms-portal-update-template-table-provider-outer-container {\n  margin-left: 0.25rem;\n}\n\n.sms-portal-top-button-container {\n  margin: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sms-portal-link-button {\n  background-color: #f05a9b;\n  font-size: 1rem;\n  font-weight: 400;\n  transition: 0.3s;\n  padding: 1.5rem 0;\n  border-radius: 5px;\n  color: #fff;\n  margin: 1rem;\n  width: 12%;\n  text-align: center;\n}\n\n.sms-portal-link-button:hover {\n  background-color: #d42d76;\n  transition: 0.3s;\n  color: #fff;\n}\n\n.sms-portal-table-section-divider {\n  height: 1px;\n  width: 100%;\n  background-color: #dcdcdc;\n}\n\n.sms-portal-temple-list-header {\n  font-size: 0.9rem;\n  color: #52616a;\n}\n\n.sms-portal-create-template-container {\n  max-width: 800px;\n  margin: 0 auto;\n  margin-top: 2rem;\n}\n\nform.sms-portal-create-template-container span {\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\nform.sms-portal-create-template-container\n  .Select.basic-single.is-clearable.is-searchable.Select--single {\n  margin-top: 0;\n}\n\nform.sms-portal-create-template-container .Select-placeholder {\n  font-size: 0.8rem;\n}\n\nform.sms-portal-create-template-container h4 {\n  font-size: 2rem;\n  text-align: center;\n  padding-bottom: 0.5rem;\n  width: fit-content;\n  margin: auto;\n  margin-bottom: 1rem;\n}\n\n.sms-content-important-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.sms-content-important-container .important-container {\n  font-size: 12px;\n  width: 35%;\n}\n\n.sms-content-important-container b span{\n  color: red;\n}\n\n.sms-portal-create-template-input-width{\n  width: 60%;\n}\n\n.sms-portal-create-template-button {\n  background-color: #f05a9b;\n  font-size: 1rem;\n  font-weight: 400;\n  transition: 0.3s;\n  border-radius: 5px;\n  color: #fff;\n  padding: 0.5rem 1rem;\n  text-align: center;\n  border: none;\n  outline: none;\n}\n\n.sms-portal-create-template-button-disabled {\n  background-color: #dcdcdc;\n  font-size: 1rem;\n  font-weight: 400;\n  transition: 0.3s;\n  border-radius: 5px;\n  color: #666;\n  padding: 0.5rem 1rem;\n  text-align: center;\n  border: none;\n  outline: none;\n  cursor: no-drop !important;\n}\n\n.sms-portal-create-template-button:hover {\n  background-color: #d42d76;\n  transition: 0.3s;\n  color: #fff;\n}\n\nform.sms-portal-create-template-container .Select-menu-outer {\n  font-size: 0.8rem;\n}\n\n.sms-portal-create-template-button-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 1rem;\n}\n\n.sms-portal-create-template-note {\n  margin-top: 1rem;\n  font-size: 0.8rem;\n}\n\n.sms-portal-create-template-sample-button {\n  border: none;\n  color: #f05a9b;\n  padding: 0;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-align: center;\n  border: none;\n  outline: none;\n  background-color: transparent;\n}\n\n.sms-portal-create-template-form-error {\n}\n\n.sms-portal-create-template-note li {\n  list-style: disc;\n  margin-left: 1rem;\n}\n\nform.sms-portal-create-template-container input.form-control {\n  margin-bottom: 0.5rem;\n}\n\n.sms-portal-textarea-counts-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.sms-portal-error-list-container {\n  list-style: disc;\n  margin-left: 1rem;\n  font-size: 0.8rem;\n}\n\nspan.sms-portal-desc-text-counter,\nspan.sms-portal-total-sms-counter {\n  text-transform: lowercase;\n  margin-top: 0.25rem;\n}\n\n.sms-todo-list-item-green {\n  color: green;\n}\n\n.sms-todo-list-item-red {\n  color: #f05a9b;\n}\n\n.sms-portal-create-template-form-error h6 {\n  margin-bottom: 0;\n  margin-top: 1rem;\n}\n\ntd.sms-portal-template-data {\n  max-width: 16rem;\n  word-wrap: break-word;\n}\n\n.sms-portal-create-template-form-errors {\n  color: rgba(214, 27, 27, 0.89);\n}\n\nform.sms-portal-create-template-container span.Select-clear-zone {\n  display: none;\n}\n\n.sms-portal-create-template-form-errors h6 {\n  margin-bottom: 0;\n}\n\n.sms-portal-success-icon {\n  display: inline-block;\n  transform: rotate(45deg);\n  height: 24px;\n  width: 12px;\n  border-bottom: 7px solid #78b13f;\n  border-right: 7px solid #78b13f;\n}\n\nspan.sms-portal-failure-icon {\n  background-color: rgba(214, 27, 27, 0.89);\n  font-size: 1.5rem;\n  border-radius: 50%;\n  padding: 0.5rem 1.2rem;\n  color: #fff;\n  line-height: 2;\n}\n\n.sms-portal-template-update-post-success-container {\n  text-align: center;\n  padding: 5rem;\n}\n\n.sms-portal-view-template-details-data-container {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  text-transform: lowercase;\n}\n\n.sms-portal-view-template-details-data-container::first-letter {\n  text-transform: capitalize;\n}\n\n.sms-portal-view-template-details-keys {\n  display: grid;\n}\n\n.sms-portal-edit-template-table-values-container .card-container {\n  width: auto;\n  max-width: 24vw;\n  max-height: 80vh;\n  overflow: auto;\n}\n\n.sms-portal-view-table-data {\n  display: grid;\n  grid-template-columns: 1.2fr 2fr;\n  align-items: center;\n  text-align: left;\n  margin-top: 1rem;\n  font-size: 0.9rem;\n}\n\nspan.sms-portal-view-table-data-value {\n  font-weight: 400;\n  font-size: 0.8rem;\n}\n\ntable.sms-portal-view-template-table button.link-type-button {\n  margin-right: 0.5rem;\n}\n\np.sms-portal-view-template-details-provider-status-text {\n  margin-left: 0.75rem;\n  margin-top: 0.5rem;\n  color: #000;\n  margin-bottom: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
